<template>
  <div
    v-if="items && items.length"
    class="featuresMobile flex flex-col gap-8 font-segoe md:gap-4"
  >
    <div
      v-for="(item, i) in items"
      :key="i"
      class="flex flex-col overflow-hidden"
    >
      <div class="w-full">
        <div
          class="bg-cover bg-center bg-no-repeat pt-[100%] sm:pt-[80%]"
          :style="getItemBgStyle(item.image)"
        ></div>
      </div>

      <div class="flex w-full flex-col bg-white p-6">
        <div
          v-if="item.title"
          class="title mb-4 text-xl uppercase leading-[1] text-slate"
          v-html="item.title"
        />

        <ul
          v-if="item.list"
          class="flex flex-col gap-y-4 text-sm leading-[1.25rem] text-slate-lighten1"
        >
          <li
            v-for="(listItem, li) in item.list"
            :key="li"
            class="relative flex min-h-[2.25rem] items-center pl-4 before:absolute before:bottom-auto before:left-0 before:top-auto before:block before:h-9 before:w-0.5 before:bg-azure"
            v-html="listItem"
          />
        </ul>

        <div
          v-else-if="item.text"
          class="text-sm leading-[1.225rem] text-slate"
          v-html="item.text"
        />

        <div v-if="item.button && item.button.link" class="mt-6">
          <UiButton
            size="md"
            :to="item.button.link"
            :target="item.button.target"
          >
            <span v-html="item.button.text" />
          </UiButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StyleValue } from 'vue';

interface Props {
  items?: any[];
}

withDefaults(defineProps<Props>(), {
  items: () => [],
});

const getItemBgStyle = (image: string): StyleValue | undefined =>
  image ? { backgroundImage: `url(${image})` } : undefined;
</script>
